import {
    AccessMessageProps, MessageProps,
} from '../types'
import React, {
    useEffect, useState,
} from 'react'

import {
    useAppDispatch, useAppSelector,
} from 'hooks'
import AccessMessageView from './AccessMessageView'
import ChannelMessage from '../ChannelMessage'
import {NinchatAccessFoundEvent} from 'api/types/events'

import {channelInviteModal} from 'actions/modal'
import {describeAccess} from 'api/action/describeAccess'
import {invitationUrlRegExp} from 'utils/regexp'
import {useUsers} from 'hooks/ninchat'


export const getAccessKey = (message: MessageProps) => {
    if (message.message_type === 'ninchat.com/text') {
        const words = message.text?.split(' ')

        const invitationUrl = words?.find((word: string) => word.match(invitationUrlRegExp))

        if (invitationUrl) {
            const urlParts = invitationUrl?.split('/#/i/')
            return urlParts?.[1]
        }
    }
    return message.access_key
}

const AccessMessage = (props: AccessMessageProps) => {
    const {message} = props
    const dispatch = useAppDispatch()

    const userChannels = useAppSelector(({ninchat}) => ninchat.user_channels)

    const user = useUsers([message.user_id || ''])[message.user_id || ''] || {}

    const [messageDetails, setMessageDetails] = useState<Partial<NinchatAccessFoundEvent> & {error?: boolean} | null>(null)
    const [channelAlreadyAdded, setChannelAlreadyAdded] = useState(true)


    const handleShowInvitationModal = () => {
        dispatch(channelInviteModal({
            accessKey: getAccessKey(message),
            noRedirectOnCancel: true,
            show: true,
        }))
    }

    useEffect(() => {
        const accessKey = getAccessKey(message)

        // describe only for text messages
        if (message.message_type === 'ninchat.com/text') {
            if (accessKey) {
                dispatch(describeAccess({access_key: accessKey}))
                    .unwrap()
                    .then(
                        (data) => { setMessageDetails(data) },
                        () => { setMessageDetails({error: true}) },
                    )
            } else {
                setMessageDetails(null)
            }
        } else {
            setMessageDetails({
                channel_attrs: message.channel_attrs,
                channel_id: message.channel_id,
                realm_attrs: message.realm_attrs,
                user_attrs: user.user_attrs,
            })
        }
    }, [])


    useEffect(() => {
        if (messageDetails && messageDetails.channel_id && userChannels) {
            const channelIdToAdd = messageDetails.channel_id

            if (channelIdToAdd && userChannels[channelIdToAdd]) {
                setChannelAlreadyAdded(true)
            } else {
                setChannelAlreadyAdded(false)
            }
        }
    }, [messageDetails, userChannels])

    // if there is no way to describe channel fallback to standard ChannelMessage
    return messageDetails === null ?
        <ChannelMessage {...props} /> :
        <AccessMessageView {...props} channelAlreadyAdded={channelAlreadyAdded} channelDetails={messageDetails} showInvitationModal={handleShowInvitationModal} />
}

export default AccessMessage
